import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { Grid, Typography } from "@material-ui/core";
import { useFileToError, isImage } from "./helpers";
import { isNotNull } from "../utils";
import { DragStateButton, DropContainer, GridGrow } from "./styles";
import { useDropzone } from "react-dropzone";
import { ImagePreview } from "./ImagePreview";
import { FileView } from "./FileView";
export function Dropzone(props) {
    const { files = [], onChange, onError, onSelect, selected, onDrop: drop, onDragEnter: dragEnter, onFileDialogCancel: fileDialogCancel, imgBackground, children, label, variant = "area", previewImages, className, ...rest } = props;
    const fileToError = useFileToError(rest);
    const onDrop = useCallback((accepted, rejected, event) => {
        if (drop) {
            drop(accepted, rejected, event);
        }
        if (onChange && accepted.length > 0) {
            onChange(props.multiple ? [...files, ...accepted] : [accepted[0]]);
        }
        if (onError) {
            const fileErrors = rejected.map(fileToError).filter(isNotNull);
            onError(fileErrors.length > 0 ? fileErrors : undefined);
        }
    }, [drop, onChange, onError, props.multiple, files, fileToError]);
    const onDragEnter = useCallback(e => {
        if (dragEnter)
            dragEnter(e);
        if (onError)
            onError(undefined);
    }, [dragEnter, onError]);
    const onFileDialogCancel = useCallback(() => {
        if (fileDialogCancel)
            fileDialogCancel();
        if (onError)
            onError(undefined);
    }, [fileDialogCancel, onError]);
    const onRemove = useCallback((file) => {
        if (onChange)
            onChange(files.filter(f => f !== file));
        if (onError)
            onError(undefined);
    }, [files, onChange, onError]);
    const dropzone = useDropzone({
        ...rest,
        onDrop,
        onDragEnter,
        onFileDialogCancel,
        noKeyboard: variant === "button"
        // noClick: variant === "button"
    });
    const { isDragActive, isDragAccept, isDragReject, getRootProps, getInputProps, open } = dropzone;
    const rootProps = {
        ...getRootProps(),
        ...(variant === "button" ? { onClick: undefined } : undefined) // workaround for noClick not working.
    };
    const dragState = {
        isDragActive,
        isDragAccept,
        isDragReject
    };
    let content;
    switch (variant) {
        case "button": {
            content = (_jsx(DragStateButton, { variant: "outlined", ...dragState, size: "large", onClick: open, children: label }));
            break;
        }
        default: {
            content = (_jsx(Typography, { color: "inherit", component: "span", children: label }));
            break;
        }
    }
    const preview = (_jsxs(Grid, { container: true, spacing: 1, alignItems: "stretch", children: [files.map((f, i) => {
                const file = (_jsx(FileView, { file: f, onRemove: onRemove, onSelect: onSelect, selected: f === selected, imgBackground: imgBackground }));
                const preview = (_jsx(ImagePreview, { file: f, onRemove: onRemove, onSelect: onSelect, selected: f === selected, imgBackground: imgBackground }));
                return (_jsx(Grid, { item: true, children: previewImages &&
                        (f instanceof File ? f.type.startsWith("image/") : isImage(f))
                        ? preview
                        : file }, i));
            }), _jsx(GridGrow, { item: true, grow: 1, children: content })] }));
    return (_jsxs(DropContainer, { variant: variant, ...dragState, ...rootProps, className: className, children: [_jsx("input", { ...getInputProps() }), typeof children === "function" ? (children(dropzone, preview)) : (_jsxs(_Fragment, { children: [children, preview] }))] }));
}
Dropzone.displayName = "DployDropzone";
//# sourceMappingURL=Dropzone.js.map